import { notification } from 'antd';
import { guestMapper } from './CreateBooking.utils.guest';
import { roomsMapper } from './CreateBooking.utils.room';
import { formActions } from './CreateBookingForm.context';

const { AppContext } = require('App.context');
const { useContext, useState, useEffect } = require('react');
const { ApiContext } = require('utils/networking/Api.context');

const useCreateBookingHook = ({ guestMockedData, formState, dispatch, onSuccess }) => {
  const {
    appState,
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    currentStep: 0,
    steps: [
      {
        startDate: null,
        endDate: null,
      },
    ],
    guestMockedData,
    formState,
    isLoading: false,
  });

  useEffect(() => {
    updateState({ guestMockedData });
  }, [guestMockedData]);

  useEffect(() => {
    updateState({ formState });
  }, [formState]);

  const actions = {
    nextStep: () => {
      updateState({ currentStep: state.currentStep + 1 });
    },
    previousStep: () => {
      updateState({ currentStep: state.currentStep - 1 });
    },
    onClose: () => {
      updateState({ currentStep: 0 });
    },
    finalStep: async () => {
      const {
        bookingDates: { startDate, endDate },
        guestsDetails: holderData,
        roomsDetails,
      } = state.formState;
      const dateFormat = 'YYYY-MM-DD';
      updateState({ isLoading: true });
      try {
        await API.createBooking({
          hotelId: getSelectedHotel()?.id,
          startDate: startDate.format(dateFormat),
          endDate: endDate.format(dateFormat),
          status: 'uncompleted',
          rooms: roomsMapper(roomsDetails),
          holderData,
          guestData: guestMapper(state.guestMockedData),
        });
        notification.success({
          message: translate('createBooking.createBookingSuccess'),
        });
        dispatch({ type: formActions.RESET_FORM });
        onSuccess();
      } catch (error) {
        notification.error({
          message: error?.response?.data?.message ?? translate('createBooking.createBookingError'),
        });
      }
      updateState({ isLoading: false });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
};

export default useCreateBookingHook;
